import styled, { css } from 'styled-components';

interface CellHeaderProps {
  width?: number | string;
  minWidth: number;
  justifyContent?: string;
  footerTextColor?: string;
  footerBackgroundColor?: string;
  footerBorderColor?: string;
  footerTextWeight?: string | number;
  footerFontSize?: string;
}

export const CellFooter = styled.div<CellHeaderProps>`
  height: 100%;
  font-family: ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};
  padding: ${({ justifyContent }) =>
    justifyContent === 'flex-start' ? '4px 5px' : '4px 2px'};
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  ${({
      minWidth,
      footerBackgroundColor,
      footerBorderColor,
      footerTextColor,
      footerTextWeight,
      footerFontSize,
    }) =>
    css`
      min-width: ${minWidth || 70}px;
      background-color: ${footerBackgroundColor};
      color: ${footerTextColor};
      border: 1px solid ${footerBorderColor};
      font-weight: ${footerTextWeight};
      font-size: ${footerFontSize};
    `}

  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
`;
